export const BASE_SUFFIXES = [
    'videoId',
    'linkText',
    'linkUrl',
    'buttonText',
    'buttonUrl',
    'desktopImageUrl',
    'tabletImageUrl',
    'mobileImageUrl',
    'descriptionText',
    'headingText',
    'imageAltText',
    'tabletImageAltText',
    'mobileImageAltText',
    'imageUrl',
    'url',
    'altText',
];
